import "./SinglePost.css";
import CommentIcon from '@mui/icons-material/Comment';
import { useState } from "react";
import { useEffect, useContext } from "react";
import axiosInstance from '../../config';
import { format } from "timeago.js";
import { Link } from 'react-router-dom';
import SocialContext from "../../context/SocialContext";
import Comment from "../../components/comment/Comment";
import Editbutton from "../../components/Edit Button/Editbutton";
import Progress from "../../components/Progress/Progress";

// for cloudinary
import { CloudinaryContext, Transformation, Image } from 'cloudinary-react';

export default function Post({ post, setfetchagain }) {
  const { user: currentuser, alertmessage } = useContext(SocialContext);
  const [like, setLike] = useState(post.likes.length)
  const [isLiked, setIsLiked] = useState(false)
  const [user, setuser] = useState({})    // this is for fetch user post't user profile,this is empty object
  const [likephoto, setlikephoto] = useState("like.png")    // this is empty object
  
  const PF = "https://socialshub.netlify.app/images/";
  const [loading, setloading] = useState(false);
  const [numberOfComment, setnumberOfComment] = useState(15);

  // function to change the color of like photo on like or dislike
  const setlikePic = () => {
    if (isLiked)
      setlikephoto("like-blue.png");
    else
      setlikephoto("like.png");
  }

  // for check is liked
  useEffect(() => {
    setIsLiked(post.likes.includes(currentuser._id));
  }, [post.likes, currentuser._id]);

  // for calculate number of likes on a post
  useEffect(() => {
    setlikePic();
  })

  // for set number fo comment
  useEffect(() => {
    setnumberOfComment(post.comments.length);
  }, [])


  // this is for fetch post's user
  useEffect(() => {
    const fetchUser = async () => {
      setloading(true);
      const response = await axiosInstance.get(`/api/users?userId=${post.userId}`);
      setuser(response.data);
      setloading(false);
    }
    fetchUser();
  }, [post.userId])

  const likeHandler = async () => {
    try {
      await axiosInstance.put(`/api/posts/${post._id}/like`, { userId: currentuser._id })
    } catch (error) {
      console.log(error);
    }
    setLike(isLiked ? like - 1 : like + 1)
    setIsLiked(!isLiked);
    setlikePic();
  }

  return (
    <div className="post">
      {loading ? <Progress size={15} /> : <div className="postWrapper">
        <div className="postTop">
          <div className="postTopLeft">
            <Link style={{ 'textDecoration': 'none' }} to={`/profile/${user._id}`}>
              <img
                className="postProfileImg"
                src={user.profilePic ? user.profilePic : PF + "person/noprofile.png"}
              />
            </Link>
            <span className="postUsername">
              <Link to={`/profile/${user._id}`} style={{ color: 'black', 'textDecoration': 'none' }}>
                {user.username}
              </Link>
              <span className="postDate">{format(post.createdAt)}</span>
            </span>
          </div>
        </div>


        <div className="postCenter">
          <span className="postText">{post.desc ? post.desc : ''}</span>
          {post.img && <img src={post.img} className="postImg" />}
        </div>


        <div className="postBottom">
          <div className="postBottomLeft">
            {like ? <img className="likeIcon" src={`${PF}like22.png`} onClick={likeHandler} alt="" /> : ""}
            {like ? <img className="likeIcon" src={`${PF}heart.png`} onClick={likeHandler} alt="" /> : ""}
            {like ? <span className="postLikeCounter">{like} people like it</span> : ""}
          </div>
        </div>
        <hr style={{ "marginTop": '8px' }} />
        <div className="like-comment-div" >
          <div className="iconblock" onClick={likeHandler}>
            <img src={PF + likephoto} />
            <span>Like {like > 0 ? like : ""}</span>
          </div>
          <div className="iconblock">
            <CommentIcon className="icon" />
            <span>Comment {numberOfComment > 0 ? numberOfComment : ""}</span>
          </div>
        </div>
        <hr style={{ "marginBottom": '10px' }} />

        <div style={{ "marginTop": '1px' }}>
          <Comment postId={post._id} setnumberOfComment={setnumberOfComment} comments={post.comments} />
        </div>

      </div>}
    </div>
  );
}